/**
 * Uppercase supplied test
 */
export const upperCaseText = (text: string) => {
  return text?.charAt(0) ? text.charAt(0).toUpperCase() + text.slice(1) : text;
};

/**
 * Remove HTML tags
 */
export const removeTags = (text: string) => {
  return text.replace(/(<([^>]+)>)/gi, "");
};

/**
 * Match context for search phrase according to type
 */
export const searchMatchContext = (result: any) => {
  return result.type === "store"
    ? `${result.title} in <strong>Stores</strong>`
    : result.type === "occasional"
    ? `${result.title} in <strong>Occasional Products</strong>`
    : result.type
    ? `${result.title} in <strong>${upperCaseText(result.type)} - ${
        result.parentTitle
          ? upperCaseText(result.parentTitle)
          : upperCaseText(result.title)
      }</strong>`
    : "";
};

/**
 * Match context for search phrase according to type
 */
export const generateUUID = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
